import { Component, type ReactNode } from 'react';
import { UnexpectedError } from '../../shared/components/UnexpectedError';

interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly failed: boolean;
}

/**
 * Last line of defence: a render error shows a translated message, not a blank page.
 * The React root's `onCaughtError` logs and reports it (root-error-hooks.ts).
 */
export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override render(): ReactNode {
    return this.state.failed ? <UnexpectedError /> : this.props.children;
  }
}
